// Admin route-tab groups — EN + TR.
//
// Admin menu simplification, part 2 (2026-10-05): screens that do the same job
// sit under one menu entry and switch with a route-tab strip. Group titles are
// also the menu labels; tab labels name each existing screen.

import type { LocalizedDict } from '../index'

type AdminHubsStrings = {
  skuMapping: {
    title: string
    storeListings: string
    unmappedOnOrders: string
    mappedListings: string
    alternateCodes: string
  }
  catalogCorrections: {
    title: string
    supplierSuggestions: string
    sellerReports: string
    vendorReplacements: string
  }
  pricing: {
    title: string
  }
  sellerApplications: {
    title: string
    leads: string
    scoreboard: string
    invitations: string
    applications: string
  }
  allFiles: {
    title: string
    folderTree: string
    fileActivity: string
  }
  catalogPdf: {
    title: string
    newCatalog: string
    generatedFiles: string
  }
  stores: {
    title: string
    stores: string
    salesGoals: string
    scorecard: string
  }
  supplierCatalog: string
}

export const adminHubsI18n: LocalizedDict<AdminHubsStrings> = {
  en: {
    skuMapping: {
      title: 'SKU Mapping',
      storeListings: 'Store listings',
      unmappedOnOrders: 'Unmapped on orders',
      mappedListings: 'Mapped listings',
      alternateCodes: 'Alternate codes',
    },
    catalogCorrections: {
      title: 'Catalog Corrections',
      supplierSuggestions: 'Supplier suggestions',
      sellerReports: 'Seller reports',
      vendorReplacements: 'Vendor replacements',
    },
    pricing: {
      title: 'Pricing',
    },
    sellerApplications: {
      title: 'Seller Applications',
      leads: 'Leads',
      scoreboard: 'Scoreboard',
      invitations: 'Invitations',
      applications: 'Applications',
    },
    allFiles: {
      title: 'All Files',
      folderTree: 'Folder tree',
      fileActivity: 'File activity',
    },
    catalogPdf: {
      title: 'Catalog PDF',
      newCatalog: 'New catalog',
      generatedFiles: 'Generated files',
    },
    stores: {
      title: 'Stores',
      stores: 'Stores',
      salesGoals: 'Sales goals',
      scorecard: 'Scorecard',
    },
    supplierCatalog: 'Supplier Catalog',
  },
  tr: {
    skuMapping: {
      title: 'SKU Eşleme',
      storeListings: 'Mağaza ilanları',
      unmappedOnOrders: 'Siparişte eşleşmeyenler',
      mappedListings: 'Eşlenmiş ilanlar',
      alternateCodes: 'Alternatif kodlar',
    },
    catalogCorrections: {
      title: 'Katalog Düzeltmeleri',
      supplierSuggestions: 'Tedarikçi önerileri',
      sellerReports: 'Satıcı bildirimleri',
      vendorReplacements: 'Tedarikçi değişimi',
    },
    pricing: {
      title: 'Fiyatlandırma',
    },
    sellerApplications: {
      title: 'Satıcı Başvuruları',
      leads: 'Adaylar',
      scoreboard: 'Skor tablosu',
      invitations: 'Davetler',
      applications: 'Başvurular',
    },
    allFiles: {
      title: 'Tüm Dosyalar',
      folderTree: 'Klasör ağacı',
      fileActivity: 'Dosya hareketleri',
    },
    catalogPdf: {
      title: 'Katalog PDF',
      newCatalog: 'Yeni katalog',
      generatedFiles: 'Oluşturulanlar',
    },
    stores: {
      title: 'Mağazalar',
      stores: 'Mağazalar',
      salesGoals: 'Satış hedefleri',
      scorecard: 'Karne',
    },
    supplierCatalog: 'Tedarikçi Kataloğu',
  },
}
